import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import 'quill/dist/quill.snow.css';
import 'react-quill/dist/quill.snow.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer, Zoom } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'semantic-ui-css/semantic.min.css';
import App from './App';
import './assets/css/main.scss';
import './assets/css/swiper-bundle.min.css';
import store from './store';
<script src='http://localhost:8097'></script>;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <Provider store={store}>
    <ToastContainer position='top-center' theme='dark' transition={Zoom} />
    <App />
  </Provider>,
);
